import Language from '../Language'

export default new Language(
  'Bulgarian',
  ['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември'],
  ['Ян', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ное', 'Дек'],
  ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
)

  ;
